module.exports = __webpack_public_path__ + "img/149.9fdd516a.jpg";